import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-incoming-call-message',
  imports: [],
  templateUrl: './incoming-call-message.component.html',
  styleUrl: './incoming-call-message.component.scss',
})
export class IncomingCallMessageComponent {
  staffName = input<string>();
  staffImage = input<string>();
  callId = input<string>();
  chatId = input<string>();

  router = inject(Router);

  NavigateToCall() {
    this.router.navigate([`/chatcall/${this.chatId()}/${this.callId()}`]);
  }
}
